import { type ReactNode } from 'react'
import { useCmLayout } from '../hooks/useCmLayout'
import { DualCtaSection } from './DualCtaSection'
import { ProBanner } from './ProBanner'

export const PricingCtaSectionWrapper = ({
  Control,
}: {
  Control: ReactNode
}) => {
  const cmLayout = useCmLayout()

  if (cmLayout === 'dual_cta') return <DualCtaSection />

  if (cmLayout === 'pro_section') {
    return (
      <>
        {Control}
        <ProBanner />
      </>
    )
  }

  return Control
}
